import React from 'react';
import WorkList from './WorkList';

const Audits = () => (
  <WorkList
    kind="audit"
    title="Audits"
    subtitle="Site surveys Fortune Home Care has sent you. Accept them, then assign a technician."
    idKey="audit_id"
    detailPath="/audits/manage-audit"
    dateLabel="Visit date"
  />
);

export default Audits;
